import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './shared/services/auth-guard.service';


const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('@app/modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'access-key',
    loadChildren: () => import('@app/modules/jurisdicted-questionnaire-answer/jurisdicted-questionnaire-answer.module')
      .then(m => m.JurisdictedQuestionnaireAnswerModule)
  },
  {
    path: 'type-fiscalization', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/type-fiscalization/type-fiscalization.module').then(m => m.TypeFiscalizationModule)
  },
  {
    path: 'category-fiscalization', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/category-fiscalization/category-fiscalization.module').then(m => m.CategoryFiscalizationModule)
  },
  {
    path: 'category-question', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/category-question/category-question.module').then(m => m.CategoryQuestionModule)
  },
  {
    path: 'questionnaire-dimension', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/question-dimension/questionnaire-dimension.module').then(m => m.QuestionnaireDimensionModule)
  },
  {
    path: 'type-question', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/type-question/type-question.module').then(m => m.TypeQuestionModule)
  },
  {
    path: 'question', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/question/question.module').then(m => m.QuestionModule)
  },
  {
    path: 'planning', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/planning/planning.module').then(m => m.PlanningModule)
  },
  {
    path: 'fiscalization', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/fiscalization/fiscalization.module').then(m => m.FiscalizationModule)
  },
  {
    path: 'jurisdicted', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/jurisdicted/jurisdicted.module').then(m => m.JurisdictedModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('@app/modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'emails',
    loadChildren: () => import('@app/modules/emails/emails.module').then(m => m.EmailModule)
  },
  {
    path: 'comunications', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/comunications/comunications.module').then(m => m.ComunicationsModule)
  },
  {
    path: 'jurisdicted/comunications', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/jurisdicted/comunications-manager/comunications-manager.module')
      .then(m => m.ComunicationsManagerModule)
  },
  {
    path: 'administrative-unit', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/administrative-unit/administrative-unit.module')
      .then(m => m.AdministrativeUnitModule)
  },
  {
    path: 'reports', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/reports/reports.module')
      .then(m => m.ReportsModule)
  },
  {
    path: 'parameters', canActivate: [AuthGuardService],
    loadChildren: () => import('@app/modules/parameters/parameters.module')
      .then(m => m.ParametersModule)
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', useHash: true, paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
